import gql from "graphql-tag";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {useFastlyQuery} from "@repo/data-gql";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    GetSetOfStandards,
    GetSetOfStandardsVariables,
} from "./__graphql-types__/GetSetOfStandards.ts";

export const GET_SET_OF_STANDARDS: GqlOperation<
    GetSetOfStandards,
    GetSetOfStandardsVariables
> = gqlOp(gql`
    query GetSetOfStandards($setId: String!, $region: String) {
        setOfStandards(setId: $setId, region: $region) {
            id
            isDiscoverable
            name
            standardRegionIds
            domains
            standards {
                id
                standardId
                description
                coverage
                children
                groupLabel
                mappedContent {
                    ... on LearnableContent {
                        id
                        contentKind
                        title
                        urlWithinStandardSet(setId: $setId)
                        defaultUrlPath
                    }
                    ... on Exercise {
                        interimAssessmentType
                    }
                }
            }
        }
    }
`);

export const useSetOfStandardsQuery = (
    setId: string,
    region: string,
): Result<GetSetOfStandards> => {
    return useFastlyQuery(GET_SET_OF_STANDARDS, {
        variables: {setId, region},
    });
};
